"use client";

import { createContext, useContext } from "react";

interface HorizontalTabContextValue {
  value: string;
  onValueChange: (value: string) => void;
}

export const HorizontalTabContext = createContext<
  HorizontalTabContextValue | undefined
>(undefined);

export function useHorizontalTabContext() {
  const context = useContext(HorizontalTabContext);
  if (!context) {
    throw new Error(
      "HorizontalTab components must be used within a HorizontalTab provider"
    );
  }
  return context;
}
